module.exports = {
    'defaultGem' : 0,
    'isBannerEnabled' : false,
    'isEnabledInterstitialWhenPopup': false,
    'isEnabledInterstitialWhenOpenInventory': false,
    'numPopupBeforeDisplayInterstitial': 3,
    'numInventoryBeforeDisplayInterstitial': 2,
};